import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Enter(): React.ReactElement {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5263 1.31582V4.26319H2.8L5.45263 1.61056L4.42105 0.578979L0 5.00003L4.42105 9.42108L5.45263 8.3895L2.8 5.73687H14V1.31582H12.5263Z" />
    </svg>
  );
}
